// App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./Panel/contexts/AuthContext";
import Login from "./Panel/components/Login";
import PanelRoutes from "./Panel/Routes";

function App() {
  return (
    <AuthProvider> {/* Wrap the entire app with AuthProvider */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<PanelRoutes />} /> {/* PanelRoutes will handle protection */}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;